import { lazy, type ComponentType, type LazyExoticComponent } from "react";

import type { FeatureCrudPermissions } from "../feature.types";

export function createLazyPlaceholderPage(
  title: string,
  description = "Coming soon...",
): LazyExoticComponent<ComponentType<unknown>> {
  return lazy(async () => ({
    default: function PlaceholderPage() {
      return (
        <div className="p-6 bg-white dark:bg-slate-800 rounded-lg shadow">
          <h1 className="text-3xl font-bold text-slate-900 dark:text-white mb-4">
            {title}
          </h1>
          <p className="text-slate-600 dark:text-slate-400">{description}</p>
        </div>
      );
    },
  }));
}

export function buildCrudPermissions(
  module: string,
  feature: string,
  overrides?: Partial<FeatureCrudPermissions>,
): FeatureCrudPermissions {
  return {
    view: overrides?.view ?? `${module}.${feature}.view`,
    create: overrides?.create ?? `${module}.${feature}.create`,
    edit: overrides?.edit ?? `${module}.${feature}.edit`,
    delete: overrides?.delete ?? `${module}.${feature}.delete`,
  };
}

export function permissionId(module: string, feature: string, action: string): string {
  return `${module}.${feature}.${action}`;
}
